import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

declare global {
  interface Window {
    // Set once React has mounted. The self-heal watchdog in index.html uses
    // this to tell a successful boot from a stale-bundle failure.
    __esgMounted?: boolean;
  }
}

const rootEl = document.getElementById("root")!;

// Production pages are prerendered (true SSG): #root already contains the
// server-rendered markup for this exact route, so we hydrate to attach React
// without repainting — eliminating the pre-load flash on refresh.
//
// Two cases use createRoot instead of hydrateRoot:
//   1. Dev — Vite serves the raw shell with an empty #root (nothing to hydrate).
//   2. Fallback — the server serves the 404 page for any non-prerendered URL
//      (e.g. /book-demo reached by direct load). Its markup is for "/404", not
//      this URL, so hydrating would mismatch. We clear it and client-render the
//      route the URL actually resolves to.
const isFallback = rootEl.dataset.fallback === "1";

if (rootEl.firstElementChild && !isFallback) {
  hydrateRoot(rootEl, <App />);
} else {
  if (isFallback) rootEl.innerHTML = "";
  createRoot(rootEl).render(<App />);
}

window.__esgMounted = true;
